
type Props = {
  title: string;
  blurb: string;
};

export function PlannedCard({ title, blurb }: Props) {
  return (
    <div className="pb-20">
      <div className="mb-6">
        <p className="text-xs uppercase tracking-wide text-amp-olive dark:text-amp-olive-dark mb-1">
          Commerce
        </p>
        <h1 className="text-2xl font-semibold text-amp-ink dark:text-amp-dark-ink">
          {title}
        </h1>
      </div>
      <div className="max-w-2xl rounded-lg border border-amp-line p-5 dark:border-amp-dark-line">
        <div className="text-xs uppercase tracking-wide font-medium text-amp-olive dark:text-amp-olive-dark mb-2">
          Planned
        </div>
        <p className="text-sm text-amp-ink dark:text-amp-dark-ink">{blurb}</p>
      </div>
    </div>
  );
}
